import classNames from "classnames/bind";
import CardWrapper from "../../utils/CardWrapper";
import { VerticalToHorizontalCardProps } from "../../interface";
import { getImage } from "../../utils/GetImage";
import { shouldRenderStatus } from "../../utils/core-utils";
import { getBadge, getStatus } from "../../utils/GetFlags";
import { VTH_CARD_LAYOUTS } from "./constants";
import AudioVideo from "./audioVideo";
import classes from "./verticalToHorizontalCard.module.scss";

const VerticalToHorizontalCard = ({
    item,
    onClick,
    renderAsButton,
    featureAttribution,
    variant,
    cardRef,
    showDescription = false,
    vthBreakpoints = VTH_CARD_LAYOUTS.HORIZONAL_ONE_COLUMN,
}: VerticalToHorizontalCardProps) => {
    const { id, title, description, image, itemType } = item;
    const { label, status } = item.flags ?? {};

    if (!id) return <div></div>;

    const cx = classNames.bind(classes);
    const containerClasses = cx(
        "verticalToHorizontalCard",
        `mobile${vthBreakpoints.mobile}`,
        `tablet${vthBreakpoints.tablet}`,
        `desktop${vthBreakpoints.desktop}`
    );

    if (itemType === "video") {
        const props = {
            id,
            item,
            containerClasses,
            variant,
            featureAttribution,
            onClick,
            vthBreakpoints,
            showDescription,
        };
        return <AudioVideo {...props} />;
    }
    const CardWrapperProps = {
        cardRef,
        item,
        onClick,
        renderAsButton,
        featureAttribution,
        variant,
    };

    return (
        <CardWrapper {...CardWrapperProps}>
            <div className={containerClasses}>
                <div className={classes.imageContainer}>
                    {getBadge(status, label, classes.vthBadge)}
                    {image &&
                        getImage(
                            { ...image, classNames: classes.vthImage },
                            vthBreakpoints
                        )}
                </div>
                <h3 className={classes.headline}>
                    <div className={classes.headlineInner}>
                        {shouldRenderStatus(item) &&
                            getStatus(status, classes.status)}
                        <span className={classes.title}>{title}</span>
                    </div>
                </h3>
                {showDescription && (
                    <p className={classes.description}>{description}</p>
                )}
            </div>
        </CardWrapper>
    );
};

export default VerticalToHorizontalCard;
